
import { debounce } from 'lodash'

export default {
    props: {
        width: {
            type: String,
            default: 'auto'
        },
        buyerSellerLinkForm: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            showInput: false,
            inputPrice: 0,
            currentPrice: 0,
            minPrice: 0,
            maxPrice: 0,
            estimatedPrice: 0,
            serviceFee: 0,
            priceReg: new RegExp(/^[0-9]\d*(\.\d{1,2})?$/),
            fixedFeeRules: [],
            ratioFeeRules: [],
            sliderValue: 0
        }
    },
    computed: {
        isValidPrice() {
            return this.priceReg.test(this.inputPrice)
        }
    },
    created() {
        // 初始化价格范围和当前价格
        this.currentPrice = Number(this.buyerSellerLinkForm.transactionPrice) || 0
        this.inputPrice = this.currentPrice
        const basePrice = this.currentPrice
        this.minPrice = Math.floor(basePrice - basePrice * 0.35) // 最低价格为原价的35%
        this.maxPrice = Math.ceil(basePrice * 1.35) // 最高价格为原价的135%
        this.sliderValue = this.currentPrice // 初始化滑块值
        this.calculateEstimatedPrice(this.currentPrice)
    },
    methods: {
        closeModal() {
            this.$parent.closeModel()
        },
        toggleInput() {
            this.showInput = true
            // 使用 nextTick 确保输入框已经渲染
            this.$nextTick(() => {
                this.$refs.priceInput.focus()
            })
        },
        handleInputBlur() {
            this.showInput = false
            let inputValue = Number(this.inputPrice)

            // 处理无效输入或0值
            if (!this.isValidPrice || inputValue === 0) {
                this.inputPrice = this.minPrice
                this.currentPrice = this.minPrice
                inputValue = this.minPrice
            } else {
                // 保持输入框的值不变
                this.currentPrice = inputValue
            }

            // 更新滑块值（始终在有效范围内）
            this.updateSliderValue()
            // 重新计算代售费和预估到手价
            this.updateFeeAndEstimatedPrice(this.currentPrice)
        },
        updateSliderValue() {
            // 滑块值始终保持在有效范围内
            if (this.currentPrice <= this.minPrice) {
                this.sliderValue = this.minPrice
            } else if (this.currentPrice >= this.maxPrice) {
                this.sliderValue = this.maxPrice
            } else {
                this.sliderValue = this.currentPrice
            }
        },
        formatTooltip(val) {
            // 如果当前输入值超出范围，显示实际输入值
            if (this.currentPrice > this.maxPrice && val === this.maxPrice) {
                return `￥${this.currentPrice}`
            }
            if (this.currentPrice < this.minPrice && val === this.minPrice) {
                return `￥${this.currentPrice}`
            }
            return `￥${val}`
        },
        handleSliderChange(value) {
            this.sliderValue = value
            this.currentPrice = value
            this.inputPrice = value // 当使用滑块时，同步更新输入框的值
            // 重新计算代售费和预估到手价
            this.updateFeeAndEstimatedPrice(value)
        },
        calculateEstimatedPrice(price) {
            // 这里模拟调用获取代售费的API
            const params = {
                goodsNo: this.buyerSellerLinkForm.goodsNo
            }
            this.$api.calculateCommission(params).then(res => {
                if (res.success) {
                    // 只处理固定费用规则
                    this.processFeeRules(res.data)
                    // 计算代售费
                    this.updateFeeAndEstimatedPrice(price)
                }
            })
        },
        processFeeRules(rules) {
            // 只保留 feeType 为 PROXY_FEE 的规则
            const proxyFeeRules = rules.filter(rule => rule.feeType === 'PROXY_FEE')

            // 分别存储 FIXED 和 RATIO 类型的规则
            this.fixedFeeRules = proxyFeeRules.filter(rule => rule.feeWay === 'FIXED')
            this.ratioFeeRules = proxyFeeRules.filter(rule => rule.feeWay === 'RATIO')
        },
        calculateTotalFee(price) {
            let totalFee = 0

            // 首先检查是否在任何FIXED区间内
            for (const fixedRule of this.fixedFeeRules) {
                if (price >= fixedRule.priceMin && price <= fixedRule.priceMax) {
                    // 如果在FIXED区间内，直接返回固定费用
                    return fixedRule.fee
                }
            }

            // 如果不在任何FIXED区间内，则检查RATIO区间
            for (const ratioRule of this.ratioFeeRules) {
                if (price >= ratioRule.priceMin && price <= ratioRule.priceMax) {
                    // 计算比例费用
                    totalFee = price * (ratioRule.fee / 100)
                    break
                }
            }

            return totalFee
        },
        updateFeeAndEstimatedPrice(price) {
            // 计算代售费
            const totalFee = this.calculateTotalFee(price)
            this.serviceFee = Number(totalFee.toFixed(2))
            this.estimatedPrice = Number((price - totalFee).toFixed(2))
        },
        handleConfirm() {
            if (!this.isValidPrice) {
                this.$message.error('请输入有效价格')
                return
            }
            let data = {
                price: this.currentPrice,
                type: this.buyerSellerLinkForm.type
            }
            this.$emit('priceChange', data)
            this.closeModal()
        }
    }
}
